import React from 'react';

export default function BlogsInfo() {
  return <div>BlogsInfo</div>;
}
